module.exports = __webpack_public_path__ + "static/media/payment-link.12502a85.png";